export enum TrustpilotWidgetVariant {
  MINI = 'mini',
  MICROSTAR = 'microstar',
  MICRO_COMBO = 'microCombo',
  CAROUSEL = 'carousel',
  SLIDER = 'slider',
}

export enum TrustpilotTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

// See https://businessapp.b2b.trustpilot.com/#/trustbox to configure this
// (You may need a login from Marketing)
export const trustpilotWidgetVariantMapping = {
  [TrustpilotWidgetVariant.MINI]: {templateId: '53aa8807dec7e10d38f59f32', styleHeight: '120px'},
  [TrustpilotWidgetVariant.MICROSTAR]: {templateId: '5419b732fbfb950b10de65e5', styleHeight: '24px'},
  [TrustpilotWidgetVariant.MICRO_COMBO]: {templateId: '5419b6ffb0d04a076446a9af', styleHeight: '24px'},
  [TrustpilotWidgetVariant.CAROUSEL]: {templateId: '53aa8912dec7e10d38f59f36', styleHeight: '140px'},
  [TrustpilotWidgetVariant.SLIDER]: {templateId: '54ad5defc6454f065c28af8b', styleHeight: '240px'},
};
